import React from "react";
import "./Styles.css";

const MyButton = ({ children, ...props }) => {
  return (
    <button {...props} className={props.cl}>
      {children}
    </button>
  );
};

export default MyButton;
